import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { onDownloadFileForSiteOwner } from '../../helpers/filesHelpers/downloadFiles';
import { fetchFilesFromOwner } from '../../helpers/filesHelpers/fetchFiles';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import UploadedFiles from './UploadedFiles';
function OwnerFiles(props) {
  const [docUploadedBySO, setDocUploadedBySO] = useState([]);
  const dispatch = useDispatch();
  const { apiConfig, pecrId, siteId } = props;

  const payload = {
    url: apiConfig.uiURL,
    pecrId: pecrId,
    siteId: siteId,
  };

  useEffect(() => {
    if (!pecrId || !siteId || !apiConfig.uiURL) return;
    async function fetchDocs() {
      try {
        const docs = await fetchFilesFromOwner(apiConfig.uiURL, pecrId, siteId);
        setDocUploadedBySO(docs);
      } catch (error) {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      }
    }
    fetchDocs();
  }, [pecrId, siteId, apiConfig.uiURL]);

  return (
    <UploadedFiles
      title="Doc_uploaded_by_SO"
      docs={docUploadedBySO}
      payload={payload}
      downloadFunction={onDownloadFileForSiteOwner}
    />
  );
}

export default OwnerFiles;
